import { actions } from './actions'

const initialState = {
  data: [],
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_CRITICALITEM_RESULT:
      return { ...state, data: action.payload }
    case 'CLEAR_ITEMS':
      return { ...state, data: { data: [] } }
    default:
      return state
  }
}
